<!-- Breadcrumb Navigation -->
<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        <li class="breadcrumb-item">
            <a routerLink="/dashboard" style="color: #003E53;">Dashboard</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Discharge Logs</li>
    </ol>
</nav>

<div class="row">
    <div class="col-xl-12">
        <app-card cardTitle="Discharge Logs" [options]="false" blockClass="table-border-style">
            <div class="row align-items-center mb-3 gx-2">
                <div class="col-12">
                    <h5 class="mb-0 text-dark fw-bold">Discharge Logs</h5>
                </div>
            </div>

            <hr class="m-0 p-0" />

            <div class="table-responsive mt-3">
                <div class="mat-elevation-z8">
                    <table mat-table [dataSource]="dataSource" class="table-bordered table-hover compact-table">

                        <!-- Sr. No Column -->
                        <ng-container matColumnDef="position">
                            <th mat-header-cell *matHeaderCellDef>Sr. No</th>
                            <td mat-cell *matCellDef="let row; let index = index">
                                {{ index + 1 + (paginator.pageIndex * paginator.pageSize) }}
                            </td>
                        </ng-container>

                        <!-- Patient Details Column -->
                        <ng-container matColumnDef="patient">
                            <th mat-header-cell *matHeaderCellDef>Patient Details</th>
                            <td mat-cell *matCellDef="let element">
                                <strong>{{ element.personId?.name || 'N/A' }}</strong><br />
                                <small>Reg No: {{ element.personId?.RegNo || 'N/A' }}</small><br />
                                <small>Age: {{ element.personId?.age || 'N/A' }} | Gender: {{ element.personId?.gender == 1 ? 'Male' : (element.personId?.gender == 2 ? 'Female' : 'Other') }}</small>
                            </td>
                        </ng-container>

                        <!-- Ward Column -->
                        <ng-container matColumnDef="ward">
                            <th mat-header-cell *matHeaderCellDef>Ward</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.wardId?.name || 'N/A' }}
                            </td>
                        </ng-container>

                        <!-- Doctor Name Column -->
                        <ng-container matColumnDef="doctor">
                            <th mat-header-cell *matHeaderCellDef>Doctor</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.doctorName || 'N/A' }}
                            </td>
                        </ng-container>

                        <!-- Remarks Column -->
                        <ng-container matColumnDef="remarks">
                            <th mat-header-cell *matHeaderCellDef>Remarks</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.remarks || 'N/A' }}
                            </td>
                        </ng-container>

                        <!-- Discharge Type Column -->
                        <ng-container matColumnDef="type">
                            <th mat-header-cell *matHeaderCellDef>Discharge Type</th>
                            <td mat-cell *matCellDef="let element">
                                <span class="{{ getDischargeTypeTag(element).class }}">
                                    {{ getDischargeTypeTag(element).label }}
                                </span>
                            </td>
                        </ng-container>

                        <!-- Created At Column -->
                        <ng-container matColumnDef="createdAt">
                            <th mat-header-cell *matHeaderCellDef>Created At</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.createdAt | date: 'dd/MM/yyyy' }}<br />
                                <small>{{ element.createdAt | date: 'hh:mm a' }}</small>
                            </td>
                        </ng-container>

                        <!-- Status/Action Column -->
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef>Status</th>
                            <td mat-cell *matCellDef="let element">
                                <span class="badge bg-success" *ngIf="element.isRead">Read</span>
                                <button *ngIf="!element.isRead" class="btn btn-sm btn-primary py-1 px-2" style="font-size: 0.8rem;" (click)="markAsRead(element)">
                                    Read
                                </button>
                            </td>
                        </ng-container>

                        <!-- Header & Data Rows -->
                        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="t_head"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                        <!-- No Data Row -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length">
                                No records found
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

            <!-- Pagination -->
            <mat-paginator #paginator [length]="total" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50, 100]"
                (page)="getLogs($event)"></mat-paginator>

        </app-card>
    </div>
</div>
